'use client';

import { usePathname } from 'next/navigation';
import Footer from './Footer';

export default function ClientFooter() {
  const pathname = usePathname();
  
  // Show margin-bottom only if pathname includes '/workshops' or ends with 'mentorship-program'
  const shouldShowMargin = pathname?.includes('/workshops') || pathname?.includes('mentorship-program');
  
  return (
    <div className={shouldShowMargin ? "mb-20 md:mb-16" : ""}>
      <Footer />
    </div>
  );
}